import {styled} from "@mui/material";

export const Wrapper = styled('div')({
    marginTop: 5,
    width: '380px'
})